import React, { useState, useEffect } from "react"
import { Modal, Button } from "react-bootstrap"
import { bookOpenIcon } from "../../constants/icons"

function SelectTopicsModal({
  show,
  onHide,
  subjectName,
  topics,
  onSelectTopics,
}) {
  const [selectedTopicId, setSelectedTopicId] = useState(null)

  useEffect(() => {
    setSelectedTopicId(null)
  }, [topics])

  const handleTopicClick = (topicId) => {
    setSelectedTopicId(topicId)
  }

  const handleGetExamPaperClick = () => {
    const selectedTopic = topics.find((topic) => topic._id === selectedTopicId)
    onSelectTopics(selectedTopic)
    onHide()
  }

  return (
    <Modal className='common-modal' show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className='bookmark-title'>
          {bookOpenIcon}
          <span>Select Topic for {subjectName}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className='topic-selection-wrapper p-0 border rounded'
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          {topics.length > 0 ? (
            topics.map((topic) => (
              <div
                key={topic._id}
                className={`topic-option py-2 px-3 ${
                  selectedTopicId === topic._id ? "bg-red text-white" : ""
                }`}
                onClick={() => handleTopicClick(topic._id)}
                role='option'
                aria-selected={selectedTopicId === topic._id}
                style={{
                  background: selectedTopicId === topic._id && "#7a5d10",
                }}
              >
                {topic.title}
              </div>
            ))
          ) : (
            <p className='text-muted p-3'>
              No topics available for this subject.
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide} className='btn-brown'>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={handleGetExamPaperClick}
          disabled={!selectedTopicId}
        >
          Get Exam Paper
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectTopicsModal
